import * as sagaEffects from 'redux-saga/effects';
import { LOCATION_CHANGE, push } from 'connected-react-router';
import { isEmpty as _isEmpty } from 'lodash';

import config from 'config/index';

import { removeNewPin } from '../actions';
import { selectNewPin } from '../selectors';

const { takeEvery, put, select } = sagaEffects;

function* handler({
    payload: {
        location: { pathname },
    },
}) {
    const addFormDefaults = yield select(selectNewPin);
    if (pathname !== config.routes.pinsAdd && !_isEmpty(addFormDefaults)) {
        yield put(removeNewPin());
    } else if (pathname === config.routes.pinsAdd && _isEmpty(addFormDefaults)) {
        yield put(push(config.routes.pins));
    }
}

export default function* () {
    yield takeEvery(LOCATION_CHANGE, handler);
}
